






































































































































import Field from '@/components/form/Field.vue';
import { Component, Provide, Ref, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { StoreActions } from '@/store';
import { required, email } from 'vuelidate/lib/validators';
import { Family, newFamily } from '@/model/family.model';
import { NotificationType } from '@/model/notification.model';

const newMember = {
  first: '',
  last: '',
  birth: '',
};
const newContact = {
  name: '',
  phone: '',
  email: '',
  newsletter: true,
};
const registrationNewFamily = {
  ...newFamily,
  members: [{ ...newMember }],
  contacts: [{ ...newContact }],
};

const postalCode = (value: string): boolean =>
  !!value.match(/\d{4}\s?[a-z|A-Z]{2}/g);

const formatPostalCode = (value: string): string => {
  const data = /(\d{4})\s?([a-z|A-Z]{2})/g.exec(value);
  return data ? `${data[1]} ${data[2]}`.toUpperCase() : '';
};

@Component({
  mixins: [validationMixin],
  components: {
    Field,
  },
  validations: {
    family: {
      name: { required },
      street: { required },
      number: { required },
      code: { required, postalCode },
      place: { required },
      members: {
        $each: {
          first: { required },
          last: { required },
          birth: { required },
        },
      },
      contacts: {
        $each: {
          name: { required },
          email: { required, email },
          phone: {},
          newsletter: {},
        },
      },
    },
  },
})
export default class Register extends Vue {
  @Ref('form') form!: HTMLFormElement;

  @Provide() family: Family = {
    ...registrationNewFamily,
    members: [{ ...newMember }],
    contacts: [{ ...newContact }],
  };

  submitting: boolean = false;

  lastNameChange(name: string, index: number) {
    if (index === 0) {
      this.family.name = name;
    }
  }

  addMember() {
    this.family.members = [
      ...this.family.members,
      { first: '', last: '', birth: '' },
    ];
  }

  removeMember(index: number) {
    this.family.members.splice(index, 1);
  }

  addContact() {
    this.family.contacts = [
      ...this.family.contacts,
      { name: '', email: '', phone: '', newsletter: true },
    ];
  }

  removeContact(index: number) {
    this.family.contacts.splice(index, 1);
  }

  async submit() {
    if (!this.$v.$invalid) {
      this.submitting = true;
      this.family.code = formatPostalCode(this.family.code);
      await this.$store.dispatch(StoreActions.SaveRegistration, this.family);
      this.reset();
      this.submitting = false;
    } else {
      this.$store.dispatch(StoreActions.Notify, {
        type: NotificationType.Warning,
        text: 'Het formulier is nog niet compleet',
      });
    }
  }

  reset() {
    this.form.reset();
    this.$v.$reset();
    this.family = {
      ...registrationNewFamily,
      members: [{ ...newMember }],
      contacts: [{ ...newContact }],
    };
  }
}
